var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{attrs:{"loading-promise":_vm.loadingPromise}},[_c('template',{slot:"fulfilled"},[_c('view-profile',{attrs:{"user":_vm.user,"albums":_vm.albums,"pages":_vm.pages}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }